import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import modules from './modules'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)
const store = new Vuex.Store({
    plugins: [createPersistedState({
        // 加上用户id，防止切换用户时数据共享
        //key: 'USER_' + (Cookies.get('userId') || '-1') + '_LOCAL_STATE',
        // 需要保存到外部存储的state
        //paths: ['activity']
    })],
    modules: modules,
})

export default store

Vue.prototype.$store = store
